import request from '@/plugin/axios'

export function ExportReport (id, data) {
  return request({
    url: '/study/export?id=' + id,
    method: 'post',
    data,
    responseType: 'arraybuffer'
  })
}

export function ExportUATReport (id) {
  return request({
    url: '/study/export-uat-report?id=' + id,
    method: 'post',
    responseType: 'arraybuffer'
  })
}

export function DownloadTemplate (data = {}) {
  return request({
    url: '/study/download-excel-tpl',
    method: 'post',
    data,
    responseType: 'blob'
  })
}
